module.exports = __webpack_public_path__ + "static/media/expense.ccd251fc.svg";